module.exports = __webpack_public_path__ + "static/p01VO-62d08a2c1d3b8c20bfb195194cd5ac79.m4a";